import {Component, HostBinding, Input} from '@angular/core';
import {XIconButtonComponent} from "../x-icon-button/x-icon-button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-x-title-row',
  standalone: true,
  imports: [XIconButtonComponent, NgIf],
  templateUrl: './x-title-row.component.html',
  styleUrl: './x-title-row.component.less',
})
export class XTitleRowComponent {
  @HostBinding('class') @Input() type: 'title' | 'subtitle' | 'large-title' = 'title';
  @Input() name: string = '';
  @Input() showTitle: boolean = true;
  @Input() color: string | undefined;
}
